module.exports = __webpack_public_path__ + "static/media/loading.5de4b439.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Loading/loading.svg
// module id = 658
// module chunks = 36